<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <app-filtro
          :fechaDesde="new Date(fechaDesde)"
          :fechaHasta="new Date(fechaHasta)"
          :impuesto="impuesto"
          :sortByDescending="sortByDescending"
          @filtrar="filtrar">
        </app-filtro>  
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Registro de Declaraciones Juradas">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="comprasImpuestos" 
              :fields="comprasImpuestosFields" 
              @row-clicked="consultar">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>              
            <template v-slot:cell(fechaComprobante)="data">
              {{ data.item.fechaComprobante | fecha }}
            </template>
            <template v-slot:cell(periodo)="data">
              <template v-if="data.item.impuestoPresentacionAnual"> 
                {{ data.item.periodo | periodoAnual }}
              </template>
              <template v-if="!data.item.impuestoPresentacionAnual"> 
                {{ data.item.periodo | periodo }}
              </template>
            </template>
            <template v-slot:cell(montoTotal)="data">
              {{ data.item.montoTotal | moneda(data.item.moneda) }}
            </template>
            <template v-slot:cell(opciones)="data">
              <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                <template slot="button-content">
                  <i class="fa fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item @click.stop="editarItem(data.item)">
                  <i class="fa fa-edit"></i>Editar DDJJ</b-dropdown-item>
                <b-dropdown-item @click.stop="borrarItem(data.item)">
                  <i class="fa fa-remove"></i>Borrar DDJJ</b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>

    <div class="fixed-btn">
      <div class="list-add-btn" @click.prevent="agregarImpuesto">
          <i class="fa fa-plus fa-2x" aria-hidden="true"></i>
      </div>
    </div>
  </div>
</template>

<script>
import Filtro from './listFiltro.vue';
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'comprasImpuestos/getField',
  mutationType: 'comprasImpuestos/updateField',
});

export default {
  name: 'ComprasImpuestos',
  components: {
    appFiltro: Filtro,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal,
  ],
  data: () => {
    return {
      comprasImpuestosFields: [
        {
          key: 'fechaComprobante',
          label: 'Fecha Comp.'
        },
        { key: 'periodo' },
        { 
          key: 'impuestoOrganismo',
          label: 'Organismo' 
        },
        { key: 'impuesto' },
        { key: 'cuenta' },
        // { key: 'comprobante' },
        // { 
        //   key: 'numero',
        //   class: 'text-right'
        // },
        {
          key: 'montoTotal',
          label: 'Importe',
          class: 'text-right'
        },
        // {
        //   key: 'montoTotal',
        //   class: 'text-right'
        // },
        {
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  computed: {
    ...mapFields([
      'comprasImpuestos',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
      'fechaDesde',
      'fechaHasta',
      'impuesto',
      'sortByDescending'
    ]),
  },
  created() {
    this.getItems();
  },  
  methods: {
    filtrar(filtro) {
      this.fechaDesde = filtro.fechaDesde;
      this.fechaHasta = filtro.fechaHasta;
      this.impuesto = filtro.impuesto;
      this.paginaActual = 1;
      
      this.getItems();
    },
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('comprasImpuestos/getComprasImpuestos')
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    agregarImpuesto () {
      this.$router.push({ name: 'CompraImpuestoABM', 
                          params: { id: 0 }
                        });
    },
    editarItem (item) {
      this.$router.push({ name: 'CompraImpuestoABM', 
                          params: { id: item.id }});
    },
    consultar (item) {
      this.$router.push({ name: 'CompraImpuestoData', 
                          params: { id: item.id }});
    },
    borrarItem (item) {
      this.showModalConfirm('¿Desea borrar la DDJJ seleccionada?', 
            this.borrar.bind(this, item.id), 'Si', null, 'No')
    },
    borrar (compraId) {
      this.showSpinner();
      this.$store.dispatch('comprasImpuestos/delete', compraId)
        .then(() => this.showModalMsj('La DDJJ se borró con éxito', this.getItems, this.getItems, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner());
    },
  },
  watch: {
    'paginaActual' : function(newVal, oldVal) {
      if ( newVal != 0 && oldVal != 0) {
        this.getItems();
      }
    },    
  }    
}
</script>

<style>
</style>
